import { Row } from '@tanstack/react-table';
import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PencilSquareIcon from 'assets/images/icons/pencil-square.svg?react';
import Button from 'components/button/Button';
import Tooltip from 'components/tooltip/Tooltip';
import { SeasonalRule } from 'models/seasonality/SeasonalRule';
import useDeleteSeasonalRuleModal from '../../modals/deleteSeasonalRuleModal/useDeleteSeasonalRuleModal';
import { ActionsCellStyled } from '../SeasonalRulesTable.styles';

const ActionsCell = ({ row }: { row: Row<SeasonalRule> }) => {
  const { t } = useTranslation();
  const { openDeleteSeasonalRuleModal } = useDeleteSeasonalRuleModal({
    rule: row.original,
  });
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`./${row.original.uid}`);
  };

  return (
    <ActionsCellStyled>
      <Tooltip
        id={`row-edit-seasonal-rule-${row.original.uid}`}
        text={t('common.edit')}
      >
        <Button
          bsStyle="link"
          data-testid="row-edit-seasonal-rule-button"
          onClick={handleEdit}
        >
          <PencilSquareIcon aria-label={t('common.edit')} />
        </Button>
      </Tooltip>

      <Tooltip
        id={`row-delete-seasonal-rule-${row.original.uid}`}
        text={t('common.delete')}
      >
        <Button
          bsStyle="link"
          data-testid="row-delete-seasonal-rule-button"
          onClick={openDeleteSeasonalRuleModal}
        >
          <Glyphicon glyph="trash" aria-label={t('common.delete')} />
        </Button>
      </Tooltip>
    </ActionsCellStyled>
  );
};

export default ActionsCell;
